import { default as bucket27h81YMHUvMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/bucket.vue?macro=true";
import { default as cadastroformulariosDCS10RB5FMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/cadastroformulario.vue?macro=true";
import { default as componentesIlEtzEN0YWMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/componentes.vue?macro=true";
import { default as developerP7eKecIhzJMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/developer.vue?macro=true";
import { default as indexzUsI7xvCEEMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/index.vue?macro=true";
import { default as mailconfiguracaob85lqgjlgzMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/mailconfiguracao.vue?macro=true";
import { default as mailtemplateszW44YNbEsQMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/mailtemplates.vue?macro=true";
import { default as permissoesI3dADcHOJPMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/permissoes.vue?macro=true";
import { default as redessociaiszabIKkOEUYMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/redessociais.vue?macro=true";
import { default as seoRVZzDLLeO4Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/seo.vue?macro=true";
import { default as _91id_93L8uOuZW2ztMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/artigos/[id].vue?macro=true";
import { default as indexFz9kSeoCXiMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/artigos/index.vue?macro=true";
import { default as settingsxZKJdGoWKSMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/artigos/settings.vue?macro=true";
import { default as carrinhosZzFVOphkBnMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/atacado/carrinhos.vue?macro=true";
import { default as indexuqIMaZwBGwMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/atacado/index.vue?macro=true";
import { default as pedidosQzg2B4DI1oMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/atacado/pedidos.vue?macro=true";
import { default as _91id_93dCP9vr6XYSMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/banners/[id].vue?macro=true";
import { default as indexJYQjSyyjkcMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/banners/index.vue?macro=true";
import { default as novo6SvA40xHH4Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/banners/novo.vue?macro=true";
import { default as settingsSngLlLTrEHMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/banners/settings.vue?macro=true";
import { default as _91componente_931KXPqvD02nMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/categorias/[componente].vue?macro=true";
import { default as _91componente_931hnwx8GSpzMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/categorias/[id]/[componente].vue?macro=true";
import { default as _91id_93ORP9Hvs99dMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/classificados/[id].vue?macro=true";
import { default as indexu9Wh5FVYZLMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/classificados/index.vue?macro=true";
import { default as menuvRGxUwD01JMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/classificados/menu.vue?macro=true";
import { default as settings6q0PrsX6W7Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/classificados/settings.vue?macro=true";
import { default as error2V77sUzmV0Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/error.vue?macro=true";
import { default as _91id_93_46_91layout_93DcJcBp8JeIMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/galerias/[id].[layout].vue?macro=true";
import { default as _91id_93gsjFH2hRziMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/galerias/[id].vue?macro=true";
import { default as indexhDLlzlP15dMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/galerias/index.vue?macro=true";
import { default as _91id_93cmlU0rsJHbMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/condominio/[id].vue?macro=true";
import { default as frmBuscaCondominios5JbH08tMpOMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/condominio/frmBuscaCondominios.vue?macro=true";
import { default as condominiossyHpaLUbloMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/condominios.vue?macro=true";
import { default as _91id_93KfnqHjG0UEMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/corretor/[id].vue?macro=true";
import { default as frmBuscaCorretoreskwSSLfW8iYMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/corretor/frmBuscaCorretores.vue?macro=true";
import { default as corretoresoM4Tq1w72oMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/corretores.vue?macro=true";
import { default as _91id_93JHVUURMHz7Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/[id].vue?macro=true";
import { default as descricao2GR5Ft3CGMMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/descricao.vue?macro=true";
import { default as enderecoNc90lD3D2FMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/endereco.vue?macro=true";
import { default as frmBuscaFRfEn1ivxMMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/frmBusca.vue?macro=true";
import { default as imagenssUw6nb5gfkMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/imagens.vue?macro=true";
import { default as indexIWZgx9KAp1Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/index.vue?macro=true";
import { default as listasSelect15VXHnVbXiMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/listasSelect.js?macro=true";
import { default as menu9M2d7nMsXbMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/menu.vue?macro=true";
import { default as _91id_93p36yngmJ92Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/proprietario/[id].vue?macro=true";
import { default as frmBuscaProprietariosok4pEearqXMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/proprietario/frmBuscaProprietarios.vue?macro=true";
import { default as proprietariosDHODDm9mWXMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/proprietarios.vue?macro=true";
import { default as settingsXZAOQ7FGTVMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/settings.vue?macro=true";
import { default as indexG8nrAhSE1UMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/index.vue?macro=true";
import { default as index64i8HI6EQhMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/index.vue?macro=true";
import { default as passwordnew5mpNN9MUGGMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/passwordnew.vue?macro=true";
import { default as passwordrecovermz9volCRFWMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/passwordrecover.vue?macro=true";
import { default as passwordrecoverokkchOW1WnT8Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/passwordrecoverok.vue?macro=true";
import { default as passwordrecovertoken6ymGFF0BPdMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/passwordrecovertoken.vue?macro=true";
import { default as index0yIPPe3NEGMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/menus/index.vue?macro=true";
import { default as index6dDMF9ZB4kMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/msmax/index.vue?macro=true";
import { default as _91id_93_46_91layout_93CWiMfkFgajMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooimagens/[id].[layout].vue?macro=true";
import { default as _91id_93N15PSiwT4eMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooimagens/[id].vue?macro=true";
import { default as indexgIxWczfca1Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooimagens/index.vue?macro=true";
import { default as indexle8IZkGFvNMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/caracteristicas/index.vue?macro=true";
import { default as aba_45atributos7KaBaRfO0rMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-atributos.vue?macro=true";
import { default as aba_45dimencoeVkoAcuSjtDMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-dimencoe.vue?macro=true";
import { default as aba_45ficha_45tecnicaSM6u6EABXBMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-ficha-tecnica.vue?macro=true";
import { default as aba_45inventarioau6yTb19N1Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-inventario.vue?macro=true";
import { default as aba_45produtos_45relacionadosi0sBQxh2qaMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-produtos-relacionados.vue?macro=true";
import { default as aba_45remessatj4iN555NjMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-remessa.vue?macro=true";
import { default as aba_45valoresSdgrYd2aQOMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-valores.vue?macro=true";
import { default as aba_45variacoesWsfghcxlllMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-variacoes.vue?macro=true";
import { default as categorias57Nhh3X0tUMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/categorias.vue?macro=true";
import { default as indexZomxjWvvofMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/index.vue?macro=true";
import { default as produto_45_91id_93xizewF7Js7Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/produto-[id].vue?macro=true";
import { default as clientest1JUWe27GEMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/clientes.vue?macro=true";
import { default as abas0TNc3R4fjTMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/abas.vue?macro=true";
import { default as clientesqiHrC2AyLQMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/clientes.vue?macro=true";
import { default as empresaF278SQEKuXMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/empresa.vue?macro=true";
import { default as index6BsXGEJO6XMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/index.vue?macro=true";
import { default as localizacaoT5gdYKHNVeMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/localizacao.vue?macro=true";
import { default as produtossFca0qK0hJMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/produtos.vue?macro=true";
import { default as indexQhhq8OD4JuMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/entregas/index.vue?macro=true";
import { default as _91id_93Zh07mKZWbMMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/[id].vue?macro=true";
import { default as fichaHW7tF2B0gUMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/ficha.vue?macro=true";
import { default as index_32copyI1Jz7GwDGaMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/index copy.vue?macro=true";
import { default as indexfLLwVagARMMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/index.vue?macro=true";
import { default as indexidKeavEd8sMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/index.vue?macro=true";
import { default as menulateral634x50gRRXMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/menulateral.vue?macro=true";
import { default as settingsTyw3nDFIsjMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/settings.vue?macro=true";
import { default as indexd9KSTAp70dMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/vendas/index.vue?macro=true";
import { default as carrinhosc0oukXQVQMMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/carrinhos.vue?macro=true";
import { default as catalogowgWtAm4MPpMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/catalogo.vue?macro=true";
import { default as indexGpi7YrAmCpMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/condicoes-parcelamento/index.vue?macro=true";
import { default as indexlctUdEUdkNMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/index.vue?macro=true";
import { default as pedidosyPS6kaoyyuMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/pedidos.vue?macro=true";
import { default as cliente_45_91id_93CHAyhxrylFMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/clientes/cliente-[id].vue?macro=true";
import { default as indexJ4AwtKXiCGMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/clientes/index.vue?macro=true";
import { default as _91id_93ECniAh0JZjMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/fabricantes/[id].vue?macro=true";
import { default as indexrmxxIuFqCQMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/fabricantes/index.vue?macro=true";
import { default as indexvCv05K8tTBMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/index.vue?macro=true";
import { default as categoriasWZwplOBLC2Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/produtos/categorias.vue?macro=true";
import { default as indexFzsnsLQItCMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/vendas/index.vue?macro=true";
import { default as aba_45avaliacoesV8XPW4qsHLMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-avaliacoes.vue?macro=true";
import { default as aba_45comentariosqLj8nLV6nQMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-comentarios.vue?macro=true";
import { default as aba_45dimencoeLQURbhDhxYMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-dimencoe.vue?macro=true";
import { default as aba_45geralEgmZ4QlFMFMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-geral.vue?macro=true";
import { default as aba_45gerenciarestoque8LTrAI3xlnMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-gerenciarestoque.vue?macro=true";
import { default as aba_45precos8nK5e5kprrMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-precos.vue?macro=true";
import { default as aba_45variacoesdPAnZOKa3iMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-variacoes.vue?macro=true";
import { default as categoriasj5n2puZZUSMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/categorias.vue?macro=true";
import { default as func_45variacoesjp4SFqXQD8Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/func-variacoes.js?macro=true";
import { default as imagensQzAOUwPlM7Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/imagens.vue?macro=true";
import { default as produto_45_91id_93Of5OlSZIFpMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/produto-[id].vue?macro=true";
import { default as produtosyMxvvHzxsTMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/produtos.vue?macro=true";
import { default as variacoesTKvFLxDMafMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/variacoes.vue?macro=true";
import { default as abasNKSv3hnzkGMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/abas.vue?macro=true";
import { default as chatbotVdmba2nYLrMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/chatbot.vue?macro=true";
import { default as clientesbqpalKajDgMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/clientes.vue?macro=true";
import { default as DEPRECATED_45empresacOAFzhSwGCMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/DEPRECATED-empresa.vue?macro=true";
import { default as erpBIrQcToEJhMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/erp.vue?macro=true";
import { default as erpprodutosKuErB9WhcOMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/erpprodutos.vue?macro=true";
import { default as index5H6l8vPAfpMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/index.vue?macro=true";
import { default as inputFormConfigvzu8k0JZlgMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/inputFormConfig.vue?macro=true";
import { default as localizacaoEF2soRoEn5Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/localizacao.vue?macro=true";
import { default as produtosnYhL5r8HhnMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/produtos.vue?macro=true";
import { default as sendformsyHkjVq1zSGMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/sendforms.js?macro=true";
import { default as indexPfquY5OlJAMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/index.vue?macro=true";
import { default as menulateraljz1ExULvr7Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/menulateral.vue?macro=true";
import { default as menuooloja7jAO3TTwZdMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/menuooloja.vue?macro=true";
import { default as settingsZd1JIHLIOpMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/settings.vue?macro=true";
import { default as indexDd1e5wmnzyMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/perfil/index.vue?macro=true";
import { default as gerapdfVT05DOQraUMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/gerapdf.vue?macro=true";
import { default as grapsvJV61fTtqXMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/graps.vue?macro=true";
import { default as indexdaLva2fcCjMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/index.vue?macro=true";
import { default as mapastHKUlPxLefMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/mapas.vue?macro=true";
import { default as megasena0HiL6IU5riMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/megasena.vue?macro=true";
import { default as myPlugindRK4R1tKylMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/plugins/myPlugin.js?macro=true";
import { default as selectEnIwE2Rp2lMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/select.vue?macro=true";
import { default as tgFg1MO4NzEMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/t.vue?macro=true";
import { default as _91id_93qvTAtBELq5Meta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/usuarios/[id].vue?macro=true";
import { default as indexS9aGFEhEjcMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/usuarios/index.vue?macro=true";
import { default as _91id_93ydAt5UCb0YMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/videos/[id].vue?macro=true";
import { default as frmBuscagwB3Xn369cMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/videos/frmBusca.vue?macro=true";
import { default as indexhQQKpKdntUMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/videos/index.vue?macro=true";
import { default as settingsuRIl0NJwAcMeta } from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/videos/settings.vue?macro=true";
export default [
  {
    name: bucket27h81YMHUvMeta?.name ?? "administracao-bucket",
    path: bucket27h81YMHUvMeta?.path ?? "/administracao/bucket",
    meta: bucket27h81YMHUvMeta || {},
    alias: bucket27h81YMHUvMeta?.alias || [],
    redirect: bucket27h81YMHUvMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/bucket.vue").then(m => m.default || m)
  },
  {
    name: cadastroformulariosDCS10RB5FMeta?.name ?? "administracao-cadastroformulario",
    path: cadastroformulariosDCS10RB5FMeta?.path ?? "/administracao/cadastroformulario",
    meta: cadastroformulariosDCS10RB5FMeta || {},
    alias: cadastroformulariosDCS10RB5FMeta?.alias || [],
    redirect: cadastroformulariosDCS10RB5FMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/cadastroformulario.vue").then(m => m.default || m)
  },
  {
    name: componentesIlEtzEN0YWMeta?.name ?? "administracao-componentes",
    path: componentesIlEtzEN0YWMeta?.path ?? "/administracao/componentes",
    meta: componentesIlEtzEN0YWMeta || {},
    alias: componentesIlEtzEN0YWMeta?.alias || [],
    redirect: componentesIlEtzEN0YWMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/componentes.vue").then(m => m.default || m)
  },
  {
    name: developerP7eKecIhzJMeta?.name ?? "administracao-developer",
    path: developerP7eKecIhzJMeta?.path ?? "/administracao/developer",
    meta: developerP7eKecIhzJMeta || {},
    alias: developerP7eKecIhzJMeta?.alias || [],
    redirect: developerP7eKecIhzJMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/developer.vue").then(m => m.default || m)
  },
  {
    name: indexzUsI7xvCEEMeta?.name ?? "administracao",
    path: indexzUsI7xvCEEMeta?.path ?? "/administracao",
    meta: indexzUsI7xvCEEMeta || {},
    alias: indexzUsI7xvCEEMeta?.alias || [],
    redirect: indexzUsI7xvCEEMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/index.vue").then(m => m.default || m)
  },
  {
    name: mailconfiguracaob85lqgjlgzMeta?.name ?? "administracao-mailconfiguracao",
    path: mailconfiguracaob85lqgjlgzMeta?.path ?? "/administracao/mailconfiguracao",
    meta: mailconfiguracaob85lqgjlgzMeta || {},
    alias: mailconfiguracaob85lqgjlgzMeta?.alias || [],
    redirect: mailconfiguracaob85lqgjlgzMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/mailconfiguracao.vue").then(m => m.default || m)
  },
  {
    name: mailtemplateszW44YNbEsQMeta?.name ?? "administracao-mailtemplates",
    path: mailtemplateszW44YNbEsQMeta?.path ?? "/administracao/mailtemplates",
    meta: mailtemplateszW44YNbEsQMeta || {},
    alias: mailtemplateszW44YNbEsQMeta?.alias || [],
    redirect: mailtemplateszW44YNbEsQMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/mailtemplates.vue").then(m => m.default || m)
  },
  {
    name: permissoesI3dADcHOJPMeta?.name ?? "administracao-permissoes",
    path: permissoesI3dADcHOJPMeta?.path ?? "/administracao/permissoes",
    meta: permissoesI3dADcHOJPMeta || {},
    alias: permissoesI3dADcHOJPMeta?.alias || [],
    redirect: permissoesI3dADcHOJPMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/permissoes.vue").then(m => m.default || m)
  },
  {
    name: redessociaiszabIKkOEUYMeta?.name ?? "administracao-redessociais",
    path: redessociaiszabIKkOEUYMeta?.path ?? "/administracao/redessociais",
    meta: redessociaiszabIKkOEUYMeta || {},
    alias: redessociaiszabIKkOEUYMeta?.alias || [],
    redirect: redessociaiszabIKkOEUYMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/redessociais.vue").then(m => m.default || m)
  },
  {
    name: seoRVZzDLLeO4Meta?.name ?? "administracao-seo",
    path: seoRVZzDLLeO4Meta?.path ?? "/administracao/seo",
    meta: seoRVZzDLLeO4Meta || {},
    alias: seoRVZzDLLeO4Meta?.alias || [],
    redirect: seoRVZzDLLeO4Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/administracao/seo.vue").then(m => m.default || m)
  },
  {
    name: _91id_93L8uOuZW2ztMeta?.name ?? "artigos-id",
    path: _91id_93L8uOuZW2ztMeta?.path ?? "/artigos/:id()",
    meta: _91id_93L8uOuZW2ztMeta || {},
    alias: _91id_93L8uOuZW2ztMeta?.alias || [],
    redirect: _91id_93L8uOuZW2ztMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/artigos/[id].vue").then(m => m.default || m)
  },
  {
    name: indexFz9kSeoCXiMeta?.name ?? "artigos",
    path: indexFz9kSeoCXiMeta?.path ?? "/artigos",
    meta: indexFz9kSeoCXiMeta || {},
    alias: indexFz9kSeoCXiMeta?.alias || [],
    redirect: indexFz9kSeoCXiMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/artigos/index.vue").then(m => m.default || m)
  },
  {
    name: settingsxZKJdGoWKSMeta?.name ?? "artigos-settings",
    path: settingsxZKJdGoWKSMeta?.path ?? "/artigos/settings",
    meta: settingsxZKJdGoWKSMeta || {},
    alias: settingsxZKJdGoWKSMeta?.alias || [],
    redirect: settingsxZKJdGoWKSMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/artigos/settings.vue").then(m => m.default || m)
  },
  {
    name: carrinhosZzFVOphkBnMeta?.name ?? "atacado-carrinhos",
    path: carrinhosZzFVOphkBnMeta?.path ?? "/atacado/carrinhos",
    meta: carrinhosZzFVOphkBnMeta || {},
    alias: carrinhosZzFVOphkBnMeta?.alias || [],
    redirect: carrinhosZzFVOphkBnMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/atacado/carrinhos.vue").then(m => m.default || m)
  },
  {
    name: indexuqIMaZwBGwMeta?.name ?? "atacado",
    path: indexuqIMaZwBGwMeta?.path ?? "/atacado",
    meta: indexuqIMaZwBGwMeta || {},
    alias: indexuqIMaZwBGwMeta?.alias || [],
    redirect: indexuqIMaZwBGwMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/atacado/index.vue").then(m => m.default || m)
  },
  {
    name: pedidosQzg2B4DI1oMeta?.name ?? "atacado-pedidos",
    path: pedidosQzg2B4DI1oMeta?.path ?? "/atacado/pedidos",
    meta: pedidosQzg2B4DI1oMeta || {},
    alias: pedidosQzg2B4DI1oMeta?.alias || [],
    redirect: pedidosQzg2B4DI1oMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/atacado/pedidos.vue").then(m => m.default || m)
  },
  {
    name: _91id_93dCP9vr6XYSMeta?.name ?? "banners-id",
    path: _91id_93dCP9vr6XYSMeta?.path ?? "/banners/:id()",
    meta: _91id_93dCP9vr6XYSMeta || {},
    alias: _91id_93dCP9vr6XYSMeta?.alias || [],
    redirect: _91id_93dCP9vr6XYSMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/banners/[id].vue").then(m => m.default || m)
  },
  {
    name: indexJYQjSyyjkcMeta?.name ?? "banners",
    path: indexJYQjSyyjkcMeta?.path ?? "/banners",
    meta: indexJYQjSyyjkcMeta || {},
    alias: indexJYQjSyyjkcMeta?.alias || [],
    redirect: indexJYQjSyyjkcMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/banners/index.vue").then(m => m.default || m)
  },
  {
    name: novo6SvA40xHH4Meta?.name ?? "banners-novo",
    path: novo6SvA40xHH4Meta?.path ?? "/banners/novo",
    meta: novo6SvA40xHH4Meta || {},
    alias: novo6SvA40xHH4Meta?.alias || [],
    redirect: novo6SvA40xHH4Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/banners/novo.vue").then(m => m.default || m)
  },
  {
    name: settingsSngLlLTrEHMeta?.name ?? "banners-settings",
    path: settingsSngLlLTrEHMeta?.path ?? "/banners/settings",
    meta: settingsSngLlLTrEHMeta || {},
    alias: settingsSngLlLTrEHMeta?.alias || [],
    redirect: settingsSngLlLTrEHMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/banners/settings.vue").then(m => m.default || m)
  },
  {
    name: _91componente_931KXPqvD02nMeta?.name ?? "categorias-componente",
    path: _91componente_931KXPqvD02nMeta?.path ?? "/categorias/:componente()",
    meta: _91componente_931KXPqvD02nMeta || {},
    alias: _91componente_931KXPqvD02nMeta?.alias || [],
    redirect: _91componente_931KXPqvD02nMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/categorias/[componente].vue").then(m => m.default || m)
  },
  {
    name: _91componente_931hnwx8GSpzMeta?.name ?? "categorias-id-componente",
    path: _91componente_931hnwx8GSpzMeta?.path ?? "/categorias/:id()/:componente()",
    meta: _91componente_931hnwx8GSpzMeta || {},
    alias: _91componente_931hnwx8GSpzMeta?.alias || [],
    redirect: _91componente_931hnwx8GSpzMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/categorias/[id]/[componente].vue").then(m => m.default || m)
  },
  {
    name: _91id_93ORP9Hvs99dMeta?.name ?? "classificados-id",
    path: _91id_93ORP9Hvs99dMeta?.path ?? "/classificados/:id()",
    meta: _91id_93ORP9Hvs99dMeta || {},
    alias: _91id_93ORP9Hvs99dMeta?.alias || [],
    redirect: _91id_93ORP9Hvs99dMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/classificados/[id].vue").then(m => m.default || m)
  },
  {
    name: indexu9Wh5FVYZLMeta?.name ?? "classificados",
    path: indexu9Wh5FVYZLMeta?.path ?? "/classificados",
    meta: indexu9Wh5FVYZLMeta || {},
    alias: indexu9Wh5FVYZLMeta?.alias || [],
    redirect: indexu9Wh5FVYZLMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/classificados/index.vue").then(m => m.default || m)
  },
  {
    name: menuvRGxUwD01JMeta?.name ?? "classificados-menu",
    path: menuvRGxUwD01JMeta?.path ?? "/classificados/menu",
    meta: menuvRGxUwD01JMeta || {},
    alias: menuvRGxUwD01JMeta?.alias || [],
    redirect: menuvRGxUwD01JMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/classificados/menu.vue").then(m => m.default || m)
  },
  {
    name: settings6q0PrsX6W7Meta?.name ?? "classificados-settings",
    path: settings6q0PrsX6W7Meta?.path ?? "/classificados/settings",
    meta: settings6q0PrsX6W7Meta || {},
    alias: settings6q0PrsX6W7Meta?.alias || [],
    redirect: settings6q0PrsX6W7Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/classificados/settings.vue").then(m => m.default || m)
  },
  {
    name: error2V77sUzmV0Meta?.name ?? "error",
    path: error2V77sUzmV0Meta?.path ?? "/error",
    meta: error2V77sUzmV0Meta || {},
    alias: error2V77sUzmV0Meta?.alias || [],
    redirect: error2V77sUzmV0Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/error.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_46_91layout_93DcJcBp8JeIMeta?.name ?? "galerias-id.layout",
    path: _91id_93_46_91layout_93DcJcBp8JeIMeta?.path ?? "/galerias/:id().:layout()",
    meta: _91id_93_46_91layout_93DcJcBp8JeIMeta || {},
    alias: _91id_93_46_91layout_93DcJcBp8JeIMeta?.alias || [],
    redirect: _91id_93_46_91layout_93DcJcBp8JeIMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/galerias/[id].[layout].vue").then(m => m.default || m)
  },
  {
    name: _91id_93gsjFH2hRziMeta?.name ?? "galerias-id",
    path: _91id_93gsjFH2hRziMeta?.path ?? "/galerias/:id()",
    meta: _91id_93gsjFH2hRziMeta || {},
    alias: _91id_93gsjFH2hRziMeta?.alias || [],
    redirect: _91id_93gsjFH2hRziMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/galerias/[id].vue").then(m => m.default || m)
  },
  {
    name: indexhDLlzlP15dMeta?.name ?? "galerias",
    path: indexhDLlzlP15dMeta?.path ?? "/galerias",
    meta: indexhDLlzlP15dMeta || {},
    alias: indexhDLlzlP15dMeta?.alias || [],
    redirect: indexhDLlzlP15dMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/galerias/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93cmlU0rsJHbMeta?.name ?? "imoveis-condominio-id",
    path: _91id_93cmlU0rsJHbMeta?.path ?? "/imoveis/condominio/:id()",
    meta: _91id_93cmlU0rsJHbMeta || {},
    alias: _91id_93cmlU0rsJHbMeta?.alias || [],
    redirect: _91id_93cmlU0rsJHbMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/condominio/[id].vue").then(m => m.default || m)
  },
  {
    name: frmBuscaCondominios5JbH08tMpOMeta?.name ?? "imoveis-condominio-frmBuscaCondominios",
    path: frmBuscaCondominios5JbH08tMpOMeta?.path ?? "/imoveis/condominio/frmBuscaCondominios",
    meta: frmBuscaCondominios5JbH08tMpOMeta || {},
    alias: frmBuscaCondominios5JbH08tMpOMeta?.alias || [],
    redirect: frmBuscaCondominios5JbH08tMpOMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/condominio/frmBuscaCondominios.vue").then(m => m.default || m)
  },
  {
    name: condominiossyHpaLUbloMeta?.name ?? "imoveis-condominios",
    path: condominiossyHpaLUbloMeta?.path ?? "/imoveis/condominios",
    meta: condominiossyHpaLUbloMeta || {},
    alias: condominiossyHpaLUbloMeta?.alias || [],
    redirect: condominiossyHpaLUbloMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/condominios.vue").then(m => m.default || m)
  },
  {
    name: _91id_93KfnqHjG0UEMeta?.name ?? "imoveis-corretor-id",
    path: _91id_93KfnqHjG0UEMeta?.path ?? "/imoveis/corretor/:id()",
    meta: _91id_93KfnqHjG0UEMeta || {},
    alias: _91id_93KfnqHjG0UEMeta?.alias || [],
    redirect: _91id_93KfnqHjG0UEMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/corretor/[id].vue").then(m => m.default || m)
  },
  {
    name: frmBuscaCorretoreskwSSLfW8iYMeta?.name ?? "imoveis-corretor-frmBuscaCorretores",
    path: frmBuscaCorretoreskwSSLfW8iYMeta?.path ?? "/imoveis/corretor/frmBuscaCorretores",
    meta: frmBuscaCorretoreskwSSLfW8iYMeta || {},
    alias: frmBuscaCorretoreskwSSLfW8iYMeta?.alias || [],
    redirect: frmBuscaCorretoreskwSSLfW8iYMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/corretor/frmBuscaCorretores.vue").then(m => m.default || m)
  },
  {
    name: corretoresoM4Tq1w72oMeta?.name ?? "imoveis-corretores",
    path: corretoresoM4Tq1w72oMeta?.path ?? "/imoveis/corretores",
    meta: corretoresoM4Tq1w72oMeta || {},
    alias: corretoresoM4Tq1w72oMeta?.alias || [],
    redirect: corretoresoM4Tq1w72oMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/corretores.vue").then(m => m.default || m)
  },
  {
    name: _91id_93JHVUURMHz7Meta?.name ?? "imoveis-imovel-id",
    path: _91id_93JHVUURMHz7Meta?.path ?? "/imoveis/imovel/:id()",
    meta: _91id_93JHVUURMHz7Meta || {},
    alias: _91id_93JHVUURMHz7Meta?.alias || [],
    redirect: _91id_93JHVUURMHz7Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/[id].vue").then(m => m.default || m)
  },
  {
    name: descricao2GR5Ft3CGMMeta?.name ?? "imoveis-imovel-descricao",
    path: descricao2GR5Ft3CGMMeta?.path ?? "/imoveis/imovel/descricao",
    meta: descricao2GR5Ft3CGMMeta || {},
    alias: descricao2GR5Ft3CGMMeta?.alias || [],
    redirect: descricao2GR5Ft3CGMMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/descricao.vue").then(m => m.default || m)
  },
  {
    name: enderecoNc90lD3D2FMeta?.name ?? "imoveis-imovel-endereco",
    path: enderecoNc90lD3D2FMeta?.path ?? "/imoveis/imovel/endereco",
    meta: enderecoNc90lD3D2FMeta || {},
    alias: enderecoNc90lD3D2FMeta?.alias || [],
    redirect: enderecoNc90lD3D2FMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/endereco.vue").then(m => m.default || m)
  },
  {
    name: frmBuscaFRfEn1ivxMMeta?.name ?? "imoveis-imovel-frmBusca",
    path: frmBuscaFRfEn1ivxMMeta?.path ?? "/imoveis/imovel/frmBusca",
    meta: frmBuscaFRfEn1ivxMMeta || {},
    alias: frmBuscaFRfEn1ivxMMeta?.alias || [],
    redirect: frmBuscaFRfEn1ivxMMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/frmBusca.vue").then(m => m.default || m)
  },
  {
    name: imagenssUw6nb5gfkMeta?.name ?? "imoveis-imovel-imagens",
    path: imagenssUw6nb5gfkMeta?.path ?? "/imoveis/imovel/imagens",
    meta: imagenssUw6nb5gfkMeta || {},
    alias: imagenssUw6nb5gfkMeta?.alias || [],
    redirect: imagenssUw6nb5gfkMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/imovel/imagens.vue").then(m => m.default || m)
  },
  {
    name: indexIWZgx9KAp1Meta?.name ?? "imoveis",
    path: indexIWZgx9KAp1Meta?.path ?? "/imoveis",
    meta: indexIWZgx9KAp1Meta || {},
    alias: indexIWZgx9KAp1Meta?.alias || [],
    redirect: indexIWZgx9KAp1Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/index.vue").then(m => m.default || m)
  },
  {
    name: listasSelect15VXHnVbXiMeta?.name ?? "imoveis-listasSelect",
    path: listasSelect15VXHnVbXiMeta?.path ?? "/imoveis/listasSelect",
    meta: listasSelect15VXHnVbXiMeta || {},
    alias: listasSelect15VXHnVbXiMeta?.alias || [],
    redirect: listasSelect15VXHnVbXiMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/listasSelect.js").then(m => m.default || m)
  },
  {
    name: menu9M2d7nMsXbMeta?.name ?? "imoveis-menu",
    path: menu9M2d7nMsXbMeta?.path ?? "/imoveis/menu",
    meta: menu9M2d7nMsXbMeta || {},
    alias: menu9M2d7nMsXbMeta?.alias || [],
    redirect: menu9M2d7nMsXbMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/menu.vue").then(m => m.default || m)
  },
  {
    name: _91id_93p36yngmJ92Meta?.name ?? "imoveis-proprietario-id",
    path: _91id_93p36yngmJ92Meta?.path ?? "/imoveis/proprietario/:id()",
    meta: _91id_93p36yngmJ92Meta || {},
    alias: _91id_93p36yngmJ92Meta?.alias || [],
    redirect: _91id_93p36yngmJ92Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/proprietario/[id].vue").then(m => m.default || m)
  },
  {
    name: frmBuscaProprietariosok4pEearqXMeta?.name ?? "imoveis-proprietario-frmBuscaProprietarios",
    path: frmBuscaProprietariosok4pEearqXMeta?.path ?? "/imoveis/proprietario/frmBuscaProprietarios",
    meta: frmBuscaProprietariosok4pEearqXMeta || {},
    alias: frmBuscaProprietariosok4pEearqXMeta?.alias || [],
    redirect: frmBuscaProprietariosok4pEearqXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/proprietario/frmBuscaProprietarios.vue").then(m => m.default || m)
  },
  {
    name: proprietariosDHODDm9mWXMeta?.name ?? "imoveis-proprietarios",
    path: proprietariosDHODDm9mWXMeta?.path ?? "/imoveis/proprietarios",
    meta: proprietariosDHODDm9mWXMeta || {},
    alias: proprietariosDHODDm9mWXMeta?.alias || [],
    redirect: proprietariosDHODDm9mWXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/proprietarios.vue").then(m => m.default || m)
  },
  {
    name: settingsXZAOQ7FGTVMeta?.name ?? "imoveis-settings",
    path: settingsXZAOQ7FGTVMeta?.path ?? "/imoveis/settings",
    meta: settingsXZAOQ7FGTVMeta || {},
    alias: settingsXZAOQ7FGTVMeta?.alias || [],
    redirect: settingsXZAOQ7FGTVMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/imoveis/settings.vue").then(m => m.default || m)
  },
  {
    name: indexG8nrAhSE1UMeta?.name ?? "index",
    path: indexG8nrAhSE1UMeta?.path ?? "/",
    meta: indexG8nrAhSE1UMeta || {},
    alias: indexG8nrAhSE1UMeta?.alias || [],
    redirect: indexG8nrAhSE1UMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index64i8HI6EQhMeta?.name ?? "login",
    path: index64i8HI6EQhMeta?.path ?? "/login",
    meta: index64i8HI6EQhMeta || {},
    alias: index64i8HI6EQhMeta?.alias || [],
    redirect: index64i8HI6EQhMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: passwordnew5mpNN9MUGGMeta?.name ?? "login-passwordnew",
    path: passwordnew5mpNN9MUGGMeta?.path ?? "/login/passwordnew",
    meta: passwordnew5mpNN9MUGGMeta || {},
    alias: passwordnew5mpNN9MUGGMeta?.alias || [],
    redirect: passwordnew5mpNN9MUGGMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/passwordnew.vue").then(m => m.default || m)
  },
  {
    name: passwordrecovermz9volCRFWMeta?.name ?? "login-passwordrecover",
    path: passwordrecovermz9volCRFWMeta?.path ?? "/login/passwordrecover",
    meta: passwordrecovermz9volCRFWMeta || {},
    alias: passwordrecovermz9volCRFWMeta?.alias || [],
    redirect: passwordrecovermz9volCRFWMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/passwordrecover.vue").then(m => m.default || m)
  },
  {
    name: passwordrecoverokkchOW1WnT8Meta?.name ?? "login-passwordrecoverok",
    path: passwordrecoverokkchOW1WnT8Meta?.path ?? "/login/passwordrecoverok",
    meta: passwordrecoverokkchOW1WnT8Meta || {},
    alias: passwordrecoverokkchOW1WnT8Meta?.alias || [],
    redirect: passwordrecoverokkchOW1WnT8Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/passwordrecoverok.vue").then(m => m.default || m)
  },
  {
    name: passwordrecovertoken6ymGFF0BPdMeta?.name ?? "login-passwordrecovertoken",
    path: passwordrecovertoken6ymGFF0BPdMeta?.path ?? "/login/passwordrecovertoken",
    meta: passwordrecovertoken6ymGFF0BPdMeta || {},
    alias: passwordrecovertoken6ymGFF0BPdMeta?.alias || [],
    redirect: passwordrecovertoken6ymGFF0BPdMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/login/passwordrecovertoken.vue").then(m => m.default || m)
  },
  {
    name: index0yIPPe3NEGMeta?.name ?? "menus",
    path: index0yIPPe3NEGMeta?.path ?? "/menus",
    meta: index0yIPPe3NEGMeta || {},
    alias: index0yIPPe3NEGMeta?.alias || [],
    redirect: index0yIPPe3NEGMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/menus/index.vue").then(m => m.default || m)
  },
  {
    name: index6dDMF9ZB4kMeta?.name ?? "msmax",
    path: index6dDMF9ZB4kMeta?.path ?? "/msmax",
    meta: index6dDMF9ZB4kMeta || {},
    alias: index6dDMF9ZB4kMeta?.alias || [],
    redirect: index6dDMF9ZB4kMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/msmax/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_46_91layout_93CWiMfkFgajMeta?.name ?? "ooimagens-id.layout",
    path: _91id_93_46_91layout_93CWiMfkFgajMeta?.path ?? "/ooimagens/:id().:layout()",
    meta: _91id_93_46_91layout_93CWiMfkFgajMeta || {},
    alias: _91id_93_46_91layout_93CWiMfkFgajMeta?.alias || [],
    redirect: _91id_93_46_91layout_93CWiMfkFgajMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooimagens/[id].[layout].vue").then(m => m.default || m)
  },
  {
    name: _91id_93N15PSiwT4eMeta?.name ?? "ooimagens-id",
    path: _91id_93N15PSiwT4eMeta?.path ?? "/ooimagens/:id()",
    meta: _91id_93N15PSiwT4eMeta || {},
    alias: _91id_93N15PSiwT4eMeta?.alias || [],
    redirect: _91id_93N15PSiwT4eMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooimagens/[id].vue").then(m => m.default || m)
  },
  {
    name: indexgIxWczfca1Meta?.name ?? "ooimagens",
    path: indexgIxWczfca1Meta?.path ?? "/ooimagens",
    meta: indexgIxWczfca1Meta || {},
    alias: indexgIxWczfca1Meta?.alias || [],
    redirect: indexgIxWczfca1Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooimagens/index.vue").then(m => m.default || m)
  },
  {
    name: indexle8IZkGFvNMeta?.name ?? "ooloja.old-caracteristicas",
    path: indexle8IZkGFvNMeta?.path ?? "/ooloja.old/caracteristicas",
    meta: indexle8IZkGFvNMeta || {},
    alias: indexle8IZkGFvNMeta?.alias || [],
    redirect: indexle8IZkGFvNMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/caracteristicas/index.vue").then(m => m.default || m)
  },
  {
    name: aba_45atributos7KaBaRfO0rMeta?.name ?? "ooloja.old-catalogo-aba-atributos",
    path: aba_45atributos7KaBaRfO0rMeta?.path ?? "/ooloja.old/catalogo/aba-atributos",
    meta: aba_45atributos7KaBaRfO0rMeta || {},
    alias: aba_45atributos7KaBaRfO0rMeta?.alias || [],
    redirect: aba_45atributos7KaBaRfO0rMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-atributos.vue").then(m => m.default || m)
  },
  {
    name: aba_45dimencoeVkoAcuSjtDMeta?.name ?? "ooloja.old-catalogo-aba-dimencoe",
    path: aba_45dimencoeVkoAcuSjtDMeta?.path ?? "/ooloja.old/catalogo/aba-dimencoe",
    meta: aba_45dimencoeVkoAcuSjtDMeta || {},
    alias: aba_45dimencoeVkoAcuSjtDMeta?.alias || [],
    redirect: aba_45dimencoeVkoAcuSjtDMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-dimencoe.vue").then(m => m.default || m)
  },
  {
    name: aba_45ficha_45tecnicaSM6u6EABXBMeta?.name ?? "ooloja.old-catalogo-aba-ficha-tecnica",
    path: aba_45ficha_45tecnicaSM6u6EABXBMeta?.path ?? "/ooloja.old/catalogo/aba-ficha-tecnica",
    meta: aba_45ficha_45tecnicaSM6u6EABXBMeta || {},
    alias: aba_45ficha_45tecnicaSM6u6EABXBMeta?.alias || [],
    redirect: aba_45ficha_45tecnicaSM6u6EABXBMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-ficha-tecnica.vue").then(m => m.default || m)
  },
  {
    name: aba_45inventarioau6yTb19N1Meta?.name ?? "ooloja.old-catalogo-aba-inventario",
    path: aba_45inventarioau6yTb19N1Meta?.path ?? "/ooloja.old/catalogo/aba-inventario",
    meta: aba_45inventarioau6yTb19N1Meta || {},
    alias: aba_45inventarioau6yTb19N1Meta?.alias || [],
    redirect: aba_45inventarioau6yTb19N1Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-inventario.vue").then(m => m.default || m)
  },
  {
    name: aba_45produtos_45relacionadosi0sBQxh2qaMeta?.name ?? "ooloja.old-catalogo-aba-produtos-relacionados",
    path: aba_45produtos_45relacionadosi0sBQxh2qaMeta?.path ?? "/ooloja.old/catalogo/aba-produtos-relacionados",
    meta: aba_45produtos_45relacionadosi0sBQxh2qaMeta || {},
    alias: aba_45produtos_45relacionadosi0sBQxh2qaMeta?.alias || [],
    redirect: aba_45produtos_45relacionadosi0sBQxh2qaMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-produtos-relacionados.vue").then(m => m.default || m)
  },
  {
    name: aba_45remessatj4iN555NjMeta?.name ?? "ooloja.old-catalogo-aba-remessa",
    path: aba_45remessatj4iN555NjMeta?.path ?? "/ooloja.old/catalogo/aba-remessa",
    meta: aba_45remessatj4iN555NjMeta || {},
    alias: aba_45remessatj4iN555NjMeta?.alias || [],
    redirect: aba_45remessatj4iN555NjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-remessa.vue").then(m => m.default || m)
  },
  {
    name: aba_45valoresSdgrYd2aQOMeta?.name ?? "ooloja.old-catalogo-aba-valores",
    path: aba_45valoresSdgrYd2aQOMeta?.path ?? "/ooloja.old/catalogo/aba-valores",
    meta: aba_45valoresSdgrYd2aQOMeta || {},
    alias: aba_45valoresSdgrYd2aQOMeta?.alias || [],
    redirect: aba_45valoresSdgrYd2aQOMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-valores.vue").then(m => m.default || m)
  },
  {
    name: aba_45variacoesWsfghcxlllMeta?.name ?? "ooloja.old-catalogo-aba-variacoes",
    path: aba_45variacoesWsfghcxlllMeta?.path ?? "/ooloja.old/catalogo/aba-variacoes",
    meta: aba_45variacoesWsfghcxlllMeta || {},
    alias: aba_45variacoesWsfghcxlllMeta?.alias || [],
    redirect: aba_45variacoesWsfghcxlllMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-variacoes.vue").then(m => m.default || m)
  },
  {
    name: categorias57Nhh3X0tUMeta?.name ?? "ooloja.old-catalogo-categorias",
    path: categorias57Nhh3X0tUMeta?.path ?? "/ooloja.old/catalogo/categorias",
    meta: categorias57Nhh3X0tUMeta || {},
    alias: categorias57Nhh3X0tUMeta?.alias || [],
    redirect: categorias57Nhh3X0tUMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/categorias.vue").then(m => m.default || m)
  },
  {
    name: indexZomxjWvvofMeta?.name ?? "ooloja.old-catalogo",
    path: indexZomxjWvvofMeta?.path ?? "/ooloja.old/catalogo",
    meta: indexZomxjWvvofMeta || {},
    alias: indexZomxjWvvofMeta?.alias || [],
    redirect: indexZomxjWvvofMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/index.vue").then(m => m.default || m)
  },
  {
    name: produto_45_91id_93xizewF7Js7Meta?.name ?? "ooloja.old-catalogo-produto-id",
    path: produto_45_91id_93xizewF7Js7Meta?.path ?? "/ooloja.old/catalogo/produto-:id()",
    meta: produto_45_91id_93xizewF7Js7Meta || {},
    alias: produto_45_91id_93xizewF7Js7Meta?.alias || [],
    redirect: produto_45_91id_93xizewF7Js7Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/produto-[id].vue").then(m => m.default || m)
  },
  {
    name: clientest1JUWe27GEMeta?.name ?? "ooloja.old-clientes",
    path: clientest1JUWe27GEMeta?.path ?? "/ooloja.old/clientes",
    meta: clientest1JUWe27GEMeta || {},
    alias: clientest1JUWe27GEMeta?.alias || [],
    redirect: clientest1JUWe27GEMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/clientes.vue").then(m => m.default || m)
  },
  {
    name: abas0TNc3R4fjTMeta?.name ?? "ooloja.old-configuracoes-abas",
    path: abas0TNc3R4fjTMeta?.path ?? "/ooloja.old/configuracoes/abas",
    meta: abas0TNc3R4fjTMeta || {},
    alias: abas0TNc3R4fjTMeta?.alias || [],
    redirect: abas0TNc3R4fjTMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/abas.vue").then(m => m.default || m)
  },
  {
    name: clientesqiHrC2AyLQMeta?.name ?? "ooloja.old-configuracoes-clientes",
    path: clientesqiHrC2AyLQMeta?.path ?? "/ooloja.old/configuracoes/clientes",
    meta: clientesqiHrC2AyLQMeta || {},
    alias: clientesqiHrC2AyLQMeta?.alias || [],
    redirect: clientesqiHrC2AyLQMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/clientes.vue").then(m => m.default || m)
  },
  {
    name: empresaF278SQEKuXMeta?.name ?? "ooloja.old-configuracoes-empresa",
    path: empresaF278SQEKuXMeta?.path ?? "/ooloja.old/configuracoes/empresa",
    meta: empresaF278SQEKuXMeta || {},
    alias: empresaF278SQEKuXMeta?.alias || [],
    redirect: empresaF278SQEKuXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/empresa.vue").then(m => m.default || m)
  },
  {
    name: index6BsXGEJO6XMeta?.name ?? "ooloja.old-configuracoes",
    path: index6BsXGEJO6XMeta?.path ?? "/ooloja.old/configuracoes",
    meta: index6BsXGEJO6XMeta || {},
    alias: index6BsXGEJO6XMeta?.alias || [],
    redirect: index6BsXGEJO6XMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/index.vue").then(m => m.default || m)
  },
  {
    name: localizacaoT5gdYKHNVeMeta?.name ?? "ooloja.old-configuracoes-localizacao",
    path: localizacaoT5gdYKHNVeMeta?.path ?? "/ooloja.old/configuracoes/localizacao",
    meta: localizacaoT5gdYKHNVeMeta || {},
    alias: localizacaoT5gdYKHNVeMeta?.alias || [],
    redirect: localizacaoT5gdYKHNVeMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/localizacao.vue").then(m => m.default || m)
  },
  {
    name: produtossFca0qK0hJMeta?.name ?? "ooloja.old-configuracoes-produtos",
    path: produtossFca0qK0hJMeta?.path ?? "/ooloja.old/configuracoes/produtos",
    meta: produtossFca0qK0hJMeta || {},
    alias: produtossFca0qK0hJMeta?.alias || [],
    redirect: produtossFca0qK0hJMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/produtos.vue").then(m => m.default || m)
  },
  {
    name: indexQhhq8OD4JuMeta?.name ?? "ooloja.old-entregas",
    path: indexQhhq8OD4JuMeta?.path ?? "/ooloja.old/entregas",
    meta: indexQhhq8OD4JuMeta || {},
    alias: indexQhhq8OD4JuMeta?.alias || [],
    redirect: indexQhhq8OD4JuMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/entregas/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Zh07mKZWbMMeta?.name ?? "ooloja.old-fichatecnica-id",
    path: _91id_93Zh07mKZWbMMeta?.path ?? "/ooloja.old/fichatecnica/:id()",
    meta: _91id_93Zh07mKZWbMMeta || {},
    alias: _91id_93Zh07mKZWbMMeta?.alias || [],
    redirect: _91id_93Zh07mKZWbMMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/[id].vue").then(m => m.default || m)
  },
  {
    name: fichaHW7tF2B0gUMeta?.name ?? "ooloja.old-fichatecnica-ficha",
    path: fichaHW7tF2B0gUMeta?.path ?? "/ooloja.old/fichatecnica/ficha",
    meta: fichaHW7tF2B0gUMeta || {},
    alias: fichaHW7tF2B0gUMeta?.alias || [],
    redirect: fichaHW7tF2B0gUMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/ficha.vue").then(m => m.default || m)
  },
  {
    name: index_32copyI1Jz7GwDGaMeta?.name ?? "ooloja.old-fichatecnica-index copy",
    path: index_32copyI1Jz7GwDGaMeta?.path ?? "/ooloja.old/fichatecnica/index%20copy",
    meta: index_32copyI1Jz7GwDGaMeta || {},
    alias: index_32copyI1Jz7GwDGaMeta?.alias || [],
    redirect: index_32copyI1Jz7GwDGaMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/index copy.vue").then(m => m.default || m)
  },
  {
    name: indexfLLwVagARMMeta?.name ?? "ooloja.old-fichatecnica",
    path: indexfLLwVagARMMeta?.path ?? "/ooloja.old/fichatecnica",
    meta: indexfLLwVagARMMeta || {},
    alias: indexfLLwVagARMMeta?.alias || [],
    redirect: indexfLLwVagARMMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/index.vue").then(m => m.default || m)
  },
  {
    name: indexidKeavEd8sMeta?.name ?? "ooloja.old",
    path: indexidKeavEd8sMeta?.path ?? "/ooloja.old",
    meta: indexidKeavEd8sMeta || {},
    alias: indexidKeavEd8sMeta?.alias || [],
    redirect: indexidKeavEd8sMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/index.vue").then(m => m.default || m)
  },
  {
    name: menulateral634x50gRRXMeta?.name ?? "ooloja.old-menulateral",
    path: menulateral634x50gRRXMeta?.path ?? "/ooloja.old/menulateral",
    meta: menulateral634x50gRRXMeta || {},
    alias: menulateral634x50gRRXMeta?.alias || [],
    redirect: menulateral634x50gRRXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/menulateral.vue").then(m => m.default || m)
  },
  {
    name: settingsTyw3nDFIsjMeta?.name ?? "ooloja.old-settings",
    path: settingsTyw3nDFIsjMeta?.path ?? "/ooloja.old/settings",
    meta: settingsTyw3nDFIsjMeta || {},
    alias: settingsTyw3nDFIsjMeta?.alias || [],
    redirect: settingsTyw3nDFIsjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/settings.vue").then(m => m.default || m)
  },
  {
    name: indexd9KSTAp70dMeta?.name ?? "ooloja.old-vendas",
    path: indexd9KSTAp70dMeta?.path ?? "/ooloja.old/vendas",
    meta: indexd9KSTAp70dMeta || {},
    alias: indexd9KSTAp70dMeta?.alias || [],
    redirect: indexd9KSTAp70dMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja.old/vendas/index.vue").then(m => m.default || m)
  },
  {
    name: carrinhosc0oukXQVQMMeta?.name ?? "ooloja-atacado-carrinhos",
    path: carrinhosc0oukXQVQMMeta?.path ?? "/ooloja/atacado/carrinhos",
    meta: carrinhosc0oukXQVQMMeta || {},
    alias: carrinhosc0oukXQVQMMeta?.alias || [],
    redirect: carrinhosc0oukXQVQMMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/carrinhos.vue").then(m => m.default || m)
  },
  {
    name: catalogowgWtAm4MPpMeta?.name ?? "ooloja-atacado-catalogo",
    path: catalogowgWtAm4MPpMeta?.path ?? "/ooloja/atacado/catalogo",
    meta: catalogowgWtAm4MPpMeta || {},
    alias: catalogowgWtAm4MPpMeta?.alias || [],
    redirect: catalogowgWtAm4MPpMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/catalogo.vue").then(m => m.default || m)
  },
  {
    name: indexGpi7YrAmCpMeta?.name ?? "ooloja-atacado-condicoes-parcelamento",
    path: indexGpi7YrAmCpMeta?.path ?? "/ooloja/atacado/condicoes-parcelamento",
    meta: indexGpi7YrAmCpMeta || {},
    alias: indexGpi7YrAmCpMeta?.alias || [],
    redirect: indexGpi7YrAmCpMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/condicoes-parcelamento/index.vue").then(m => m.default || m)
  },
  {
    name: indexlctUdEUdkNMeta?.name ?? "ooloja-atacado",
    path: indexlctUdEUdkNMeta?.path ?? "/ooloja/atacado",
    meta: indexlctUdEUdkNMeta || {},
    alias: indexlctUdEUdkNMeta?.alias || [],
    redirect: indexlctUdEUdkNMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/index.vue").then(m => m.default || m)
  },
  {
    name: pedidosyPS6kaoyyuMeta?.name ?? "ooloja-atacado-pedidos",
    path: pedidosyPS6kaoyyuMeta?.path ?? "/ooloja/atacado/pedidos",
    meta: pedidosyPS6kaoyyuMeta || {},
    alias: pedidosyPS6kaoyyuMeta?.alias || [],
    redirect: pedidosyPS6kaoyyuMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/atacado/pedidos.vue").then(m => m.default || m)
  },
  {
    name: cliente_45_91id_93CHAyhxrylFMeta?.name ?? "ooloja-cadastros-clientes-cliente-id",
    path: cliente_45_91id_93CHAyhxrylFMeta?.path ?? "/ooloja/cadastros/clientes/cliente-:id()",
    meta: cliente_45_91id_93CHAyhxrylFMeta || {},
    alias: cliente_45_91id_93CHAyhxrylFMeta?.alias || [],
    redirect: cliente_45_91id_93CHAyhxrylFMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/clientes/cliente-[id].vue").then(m => m.default || m)
  },
  {
    name: indexJ4AwtKXiCGMeta?.name ?? "ooloja-cadastros-clientes",
    path: indexJ4AwtKXiCGMeta?.path ?? "/ooloja/cadastros/clientes",
    meta: indexJ4AwtKXiCGMeta || {},
    alias: indexJ4AwtKXiCGMeta?.alias || [],
    redirect: indexJ4AwtKXiCGMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/clientes/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ECniAh0JZjMeta?.name ?? "ooloja-cadastros-fabricantes-id",
    path: _91id_93ECniAh0JZjMeta?.path ?? "/ooloja/cadastros/fabricantes/:id()",
    meta: _91id_93ECniAh0JZjMeta || {},
    alias: _91id_93ECniAh0JZjMeta?.alias || [],
    redirect: _91id_93ECniAh0JZjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/fabricantes/[id].vue").then(m => m.default || m)
  },
  {
    name: indexrmxxIuFqCQMeta?.name ?? "ooloja-cadastros-fabricantes",
    path: indexrmxxIuFqCQMeta?.path ?? "/ooloja/cadastros/fabricantes",
    meta: indexrmxxIuFqCQMeta || {},
    alias: indexrmxxIuFqCQMeta?.alias || [],
    redirect: indexrmxxIuFqCQMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/fabricantes/index.vue").then(m => m.default || m)
  },
  {
    name: indexvCv05K8tTBMeta?.name ?? "ooloja-cadastros",
    path: indexvCv05K8tTBMeta?.path ?? "/ooloja/cadastros",
    meta: indexvCv05K8tTBMeta || {},
    alias: indexvCv05K8tTBMeta?.alias || [],
    redirect: indexvCv05K8tTBMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/index.vue").then(m => m.default || m)
  },
  {
    name: categoriasWZwplOBLC2Meta?.name ?? "ooloja-cadastros-produtos-categorias",
    path: categoriasWZwplOBLC2Meta?.path ?? "/ooloja/cadastros/produtos/categorias",
    meta: categoriasWZwplOBLC2Meta || {},
    alias: categoriasWZwplOBLC2Meta?.alias || [],
    redirect: categoriasWZwplOBLC2Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/produtos/categorias.vue").then(m => m.default || m)
  },
  {
    name: indexFzsnsLQItCMeta?.name ?? "ooloja-cadastros-vendas",
    path: indexFzsnsLQItCMeta?.path ?? "/ooloja/cadastros/vendas",
    meta: indexFzsnsLQItCMeta || {},
    alias: indexFzsnsLQItCMeta?.alias || [],
    redirect: indexFzsnsLQItCMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/cadastros/vendas/index.vue").then(m => m.default || m)
  },
  {
    name: aba_45avaliacoesV8XPW4qsHLMeta?.name ?? "ooloja-catalogo-aba-avaliacoes",
    path: aba_45avaliacoesV8XPW4qsHLMeta?.path ?? "/ooloja/catalogo/aba-avaliacoes",
    meta: aba_45avaliacoesV8XPW4qsHLMeta || {},
    alias: aba_45avaliacoesV8XPW4qsHLMeta?.alias || [],
    redirect: aba_45avaliacoesV8XPW4qsHLMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-avaliacoes.vue").then(m => m.default || m)
  },
  {
    name: aba_45comentariosqLj8nLV6nQMeta?.name ?? "ooloja-catalogo-aba-comentarios",
    path: aba_45comentariosqLj8nLV6nQMeta?.path ?? "/ooloja/catalogo/aba-comentarios",
    meta: aba_45comentariosqLj8nLV6nQMeta || {},
    alias: aba_45comentariosqLj8nLV6nQMeta?.alias || [],
    redirect: aba_45comentariosqLj8nLV6nQMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-comentarios.vue").then(m => m.default || m)
  },
  {
    name: aba_45dimencoeLQURbhDhxYMeta?.name ?? "ooloja-catalogo-aba-dimencoe",
    path: aba_45dimencoeLQURbhDhxYMeta?.path ?? "/ooloja/catalogo/aba-dimencoe",
    meta: aba_45dimencoeLQURbhDhxYMeta || {},
    alias: aba_45dimencoeLQURbhDhxYMeta?.alias || [],
    redirect: aba_45dimencoeLQURbhDhxYMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-dimencoe.vue").then(m => m.default || m)
  },
  {
    name: aba_45geralEgmZ4QlFMFMeta?.name ?? "ooloja-catalogo-aba-geral",
    path: aba_45geralEgmZ4QlFMFMeta?.path ?? "/ooloja/catalogo/aba-geral",
    meta: aba_45geralEgmZ4QlFMFMeta || {},
    alias: aba_45geralEgmZ4QlFMFMeta?.alias || [],
    redirect: aba_45geralEgmZ4QlFMFMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-geral.vue").then(m => m.default || m)
  },
  {
    name: aba_45gerenciarestoque8LTrAI3xlnMeta?.name ?? "ooloja-catalogo-aba-gerenciarestoque",
    path: aba_45gerenciarestoque8LTrAI3xlnMeta?.path ?? "/ooloja/catalogo/aba-gerenciarestoque",
    meta: aba_45gerenciarestoque8LTrAI3xlnMeta || {},
    alias: aba_45gerenciarestoque8LTrAI3xlnMeta?.alias || [],
    redirect: aba_45gerenciarestoque8LTrAI3xlnMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-gerenciarestoque.vue").then(m => m.default || m)
  },
  {
    name: aba_45precos8nK5e5kprrMeta?.name ?? "ooloja-catalogo-aba-precos",
    path: aba_45precos8nK5e5kprrMeta?.path ?? "/ooloja/catalogo/aba-precos",
    meta: aba_45precos8nK5e5kprrMeta || {},
    alias: aba_45precos8nK5e5kprrMeta?.alias || [],
    redirect: aba_45precos8nK5e5kprrMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-precos.vue").then(m => m.default || m)
  },
  {
    name: aba_45variacoesdPAnZOKa3iMeta?.name ?? "ooloja-catalogo-aba-variacoes",
    path: aba_45variacoesdPAnZOKa3iMeta?.path ?? "/ooloja/catalogo/aba-variacoes",
    meta: aba_45variacoesdPAnZOKa3iMeta || {},
    alias: aba_45variacoesdPAnZOKa3iMeta?.alias || [],
    redirect: aba_45variacoesdPAnZOKa3iMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-variacoes.vue").then(m => m.default || m)
  },
  {
    name: categoriasj5n2puZZUSMeta?.name ?? "ooloja-catalogo-categorias",
    path: categoriasj5n2puZZUSMeta?.path ?? "/ooloja/catalogo/categorias",
    meta: categoriasj5n2puZZUSMeta || {},
    alias: categoriasj5n2puZZUSMeta?.alias || [],
    redirect: categoriasj5n2puZZUSMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/categorias.vue").then(m => m.default || m)
  },
  {
    name: func_45variacoesjp4SFqXQD8Meta?.name ?? "ooloja-catalogo-func-variacoes",
    path: func_45variacoesjp4SFqXQD8Meta?.path ?? "/ooloja/catalogo/func-variacoes",
    meta: func_45variacoesjp4SFqXQD8Meta || {},
    alias: func_45variacoesjp4SFqXQD8Meta?.alias || [],
    redirect: func_45variacoesjp4SFqXQD8Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/func-variacoes.js").then(m => m.default || m)
  },
  {
    name: imagensQzAOUwPlM7Meta?.name ?? "ooloja-catalogo-imagens",
    path: imagensQzAOUwPlM7Meta?.path ?? "/ooloja/catalogo/imagens",
    meta: imagensQzAOUwPlM7Meta || {},
    alias: imagensQzAOUwPlM7Meta?.alias || [],
    redirect: imagensQzAOUwPlM7Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/imagens.vue").then(m => m.default || m)
  },
  {
    name: produto_45_91id_93Of5OlSZIFpMeta?.name ?? "ooloja-catalogo-produto-id",
    path: produto_45_91id_93Of5OlSZIFpMeta?.path ?? "/ooloja/catalogo/produto-:id()",
    meta: produto_45_91id_93Of5OlSZIFpMeta || {},
    alias: produto_45_91id_93Of5OlSZIFpMeta?.alias || [],
    redirect: produto_45_91id_93Of5OlSZIFpMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/produto-[id].vue").then(m => m.default || m)
  },
  {
    name: produtosyMxvvHzxsTMeta?.name ?? "ooloja-catalogo-produtos",
    path: produtosyMxvvHzxsTMeta?.path ?? "/ooloja/catalogo/produtos",
    meta: produtosyMxvvHzxsTMeta || {},
    alias: produtosyMxvvHzxsTMeta?.alias || [],
    redirect: produtosyMxvvHzxsTMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/produtos.vue").then(m => m.default || m)
  },
  {
    name: variacoesTKvFLxDMafMeta?.name ?? "ooloja-catalogo-variacoes",
    path: variacoesTKvFLxDMafMeta?.path ?? "/ooloja/catalogo/variacoes",
    meta: variacoesTKvFLxDMafMeta || {},
    alias: variacoesTKvFLxDMafMeta?.alias || [],
    redirect: variacoesTKvFLxDMafMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/catalogo/variacoes.vue").then(m => m.default || m)
  },
  {
    name: abasNKSv3hnzkGMeta?.name ?? "ooloja-configuracoes-abas",
    path: abasNKSv3hnzkGMeta?.path ?? "/ooloja/configuracoes/abas",
    meta: abasNKSv3hnzkGMeta || {},
    alias: abasNKSv3hnzkGMeta?.alias || [],
    redirect: abasNKSv3hnzkGMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/abas.vue").then(m => m.default || m)
  },
  {
    name: chatbotVdmba2nYLrMeta?.name ?? "ooloja-configuracoes-chatbot",
    path: chatbotVdmba2nYLrMeta?.path ?? "/ooloja/configuracoes/chatbot",
    meta: chatbotVdmba2nYLrMeta || {},
    alias: chatbotVdmba2nYLrMeta?.alias || [],
    redirect: chatbotVdmba2nYLrMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/chatbot.vue").then(m => m.default || m)
  },
  {
    name: clientesbqpalKajDgMeta?.name ?? "ooloja-configuracoes-clientes",
    path: clientesbqpalKajDgMeta?.path ?? "/ooloja/configuracoes/clientes",
    meta: clientesbqpalKajDgMeta || {},
    alias: clientesbqpalKajDgMeta?.alias || [],
    redirect: clientesbqpalKajDgMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/clientes.vue").then(m => m.default || m)
  },
  {
    name: DEPRECATED_45empresacOAFzhSwGCMeta?.name ?? "ooloja-configuracoes-DEPRECATED-empresa",
    path: DEPRECATED_45empresacOAFzhSwGCMeta?.path ?? "/ooloja/configuracoes/DEPRECATED-empresa",
    meta: DEPRECATED_45empresacOAFzhSwGCMeta || {},
    alias: DEPRECATED_45empresacOAFzhSwGCMeta?.alias || [],
    redirect: DEPRECATED_45empresacOAFzhSwGCMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/DEPRECATED-empresa.vue").then(m => m.default || m)
  },
  {
    name: erpBIrQcToEJhMeta?.name ?? "ooloja-configuracoes-erp",
    path: erpBIrQcToEJhMeta?.path ?? "/ooloja/configuracoes/erp",
    meta: erpBIrQcToEJhMeta || {},
    alias: erpBIrQcToEJhMeta?.alias || [],
    redirect: erpBIrQcToEJhMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/erp.vue").then(m => m.default || m)
  },
  {
    name: erpprodutosKuErB9WhcOMeta?.name ?? "ooloja-configuracoes-erpprodutos",
    path: erpprodutosKuErB9WhcOMeta?.path ?? "/ooloja/configuracoes/erpprodutos",
    meta: erpprodutosKuErB9WhcOMeta || {},
    alias: erpprodutosKuErB9WhcOMeta?.alias || [],
    redirect: erpprodutosKuErB9WhcOMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/erpprodutos.vue").then(m => m.default || m)
  },
  {
    name: index5H6l8vPAfpMeta?.name ?? "ooloja-configuracoes",
    path: index5H6l8vPAfpMeta?.path ?? "/ooloja/configuracoes",
    meta: index5H6l8vPAfpMeta || {},
    alias: index5H6l8vPAfpMeta?.alias || [],
    redirect: index5H6l8vPAfpMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/index.vue").then(m => m.default || m)
  },
  {
    name: inputFormConfigvzu8k0JZlgMeta?.name ?? "ooloja-configuracoes-inputFormConfig",
    path: inputFormConfigvzu8k0JZlgMeta?.path ?? "/ooloja/configuracoes/inputFormConfig",
    meta: inputFormConfigvzu8k0JZlgMeta || {},
    alias: inputFormConfigvzu8k0JZlgMeta?.alias || [],
    redirect: inputFormConfigvzu8k0JZlgMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/inputFormConfig.vue").then(m => m.default || m)
  },
  {
    name: localizacaoEF2soRoEn5Meta?.name ?? "ooloja-configuracoes-localizacao",
    path: localizacaoEF2soRoEn5Meta?.path ?? "/ooloja/configuracoes/localizacao",
    meta: localizacaoEF2soRoEn5Meta || {},
    alias: localizacaoEF2soRoEn5Meta?.alias || [],
    redirect: localizacaoEF2soRoEn5Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/localizacao.vue").then(m => m.default || m)
  },
  {
    name: produtosnYhL5r8HhnMeta?.name ?? "ooloja-configuracoes-produtos",
    path: produtosnYhL5r8HhnMeta?.path ?? "/ooloja/configuracoes/produtos",
    meta: produtosnYhL5r8HhnMeta || {},
    alias: produtosnYhL5r8HhnMeta?.alias || [],
    redirect: produtosnYhL5r8HhnMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/produtos.vue").then(m => m.default || m)
  },
  {
    name: sendformsyHkjVq1zSGMeta?.name ?? "ooloja-configuracoes-sendforms",
    path: sendformsyHkjVq1zSGMeta?.path ?? "/ooloja/configuracoes/sendforms",
    meta: sendformsyHkjVq1zSGMeta || {},
    alias: sendformsyHkjVq1zSGMeta?.alias || [],
    redirect: sendformsyHkjVq1zSGMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/sendforms.js").then(m => m.default || m)
  },
  {
    name: indexPfquY5OlJAMeta?.name ?? "ooloja",
    path: indexPfquY5OlJAMeta?.path ?? "/ooloja",
    meta: indexPfquY5OlJAMeta || {},
    alias: indexPfquY5OlJAMeta?.alias || [],
    redirect: indexPfquY5OlJAMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/index.vue").then(m => m.default || m)
  },
  {
    name: menulateraljz1ExULvr7Meta?.name ?? "ooloja-menulateral",
    path: menulateraljz1ExULvr7Meta?.path ?? "/ooloja/menulateral",
    meta: menulateraljz1ExULvr7Meta || {},
    alias: menulateraljz1ExULvr7Meta?.alias || [],
    redirect: menulateraljz1ExULvr7Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/menulateral.vue").then(m => m.default || m)
  },
  {
    name: menuooloja7jAO3TTwZdMeta?.name ?? "ooloja-menuooloja",
    path: menuooloja7jAO3TTwZdMeta?.path ?? "/ooloja/menuooloja",
    meta: menuooloja7jAO3TTwZdMeta || {},
    alias: menuooloja7jAO3TTwZdMeta?.alias || [],
    redirect: menuooloja7jAO3TTwZdMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/menuooloja.vue").then(m => m.default || m)
  },
  {
    name: settingsZd1JIHLIOpMeta?.name ?? "ooloja-settings",
    path: settingsZd1JIHLIOpMeta?.path ?? "/ooloja/settings",
    meta: settingsZd1JIHLIOpMeta || {},
    alias: settingsZd1JIHLIOpMeta?.alias || [],
    redirect: settingsZd1JIHLIOpMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/ooloja/settings.vue").then(m => m.default || m)
  },
  {
    name: indexDd1e5wmnzyMeta?.name ?? "perfil",
    path: indexDd1e5wmnzyMeta?.path ?? "/perfil",
    meta: indexDd1e5wmnzyMeta || {},
    alias: indexDd1e5wmnzyMeta?.alias || [],
    redirect: indexDd1e5wmnzyMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/perfil/index.vue").then(m => m.default || m)
  },
  {
    name: gerapdfVT05DOQraUMeta?.name ?? "testes-gerapdf",
    path: gerapdfVT05DOQraUMeta?.path ?? "/testes/gerapdf",
    meta: gerapdfVT05DOQraUMeta || {},
    alias: gerapdfVT05DOQraUMeta?.alias || [],
    redirect: gerapdfVT05DOQraUMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/gerapdf.vue").then(m => m.default || m)
  },
  {
    name: grapsvJV61fTtqXMeta?.name ?? "testes-graps",
    path: grapsvJV61fTtqXMeta?.path ?? "/testes/graps",
    meta: grapsvJV61fTtqXMeta || {},
    alias: grapsvJV61fTtqXMeta?.alias || [],
    redirect: grapsvJV61fTtqXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/graps.vue").then(m => m.default || m)
  },
  {
    name: indexdaLva2fcCjMeta?.name ?? "testes",
    path: indexdaLva2fcCjMeta?.path ?? "/testes",
    meta: indexdaLva2fcCjMeta || {},
    alias: indexdaLva2fcCjMeta?.alias || [],
    redirect: indexdaLva2fcCjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/index.vue").then(m => m.default || m)
  },
  {
    name: mapastHKUlPxLefMeta?.name ?? "testes-mapas",
    path: mapastHKUlPxLefMeta?.path ?? "/testes/mapas",
    meta: mapastHKUlPxLefMeta || {},
    alias: mapastHKUlPxLefMeta?.alias || [],
    redirect: mapastHKUlPxLefMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/mapas.vue").then(m => m.default || m)
  },
  {
    name: megasena0HiL6IU5riMeta?.name ?? "testes-megasena",
    path: megasena0HiL6IU5riMeta?.path ?? "/testes/megasena",
    meta: megasena0HiL6IU5riMeta || {},
    alias: megasena0HiL6IU5riMeta?.alias || [],
    redirect: megasena0HiL6IU5riMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/megasena.vue").then(m => m.default || m)
  },
  {
    name: myPlugindRK4R1tKylMeta?.name ?? "testes-plugins-myPlugin",
    path: myPlugindRK4R1tKylMeta?.path ?? "/testes/plugins/myPlugin",
    meta: myPlugindRK4R1tKylMeta || {},
    alias: myPlugindRK4R1tKylMeta?.alias || [],
    redirect: myPlugindRK4R1tKylMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/plugins/myPlugin.js").then(m => m.default || m)
  },
  {
    name: selectEnIwE2Rp2lMeta?.name ?? "testes-select",
    path: selectEnIwE2Rp2lMeta?.path ?? "/testes/select",
    meta: selectEnIwE2Rp2lMeta || {},
    alias: selectEnIwE2Rp2lMeta?.alias || [],
    redirect: selectEnIwE2Rp2lMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/select.vue").then(m => m.default || m)
  },
  {
    name: tgFg1MO4NzEMeta?.name ?? "testes-t",
    path: tgFg1MO4NzEMeta?.path ?? "/testes/t",
    meta: tgFg1MO4NzEMeta || {},
    alias: tgFg1MO4NzEMeta?.alias || [],
    redirect: tgFg1MO4NzEMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/testes/t.vue").then(m => m.default || m)
  },
  {
    name: _91id_93qvTAtBELq5Meta?.name ?? "usuarios-id",
    path: _91id_93qvTAtBELq5Meta?.path ?? "/usuarios/:id()",
    meta: _91id_93qvTAtBELq5Meta || {},
    alias: _91id_93qvTAtBELq5Meta?.alias || [],
    redirect: _91id_93qvTAtBELq5Meta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/usuarios/[id].vue").then(m => m.default || m)
  },
  {
    name: indexS9aGFEhEjcMeta?.name ?? "usuarios",
    path: indexS9aGFEhEjcMeta?.path ?? "/usuarios",
    meta: indexS9aGFEhEjcMeta || {},
    alias: indexS9aGFEhEjcMeta?.alias || [],
    redirect: indexS9aGFEhEjcMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/usuarios/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ydAt5UCb0YMeta?.name ?? "videos-id",
    path: _91id_93ydAt5UCb0YMeta?.path ?? "/videos/:id()",
    meta: _91id_93ydAt5UCb0YMeta || {},
    alias: _91id_93ydAt5UCb0YMeta?.alias || [],
    redirect: _91id_93ydAt5UCb0YMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/videos/[id].vue").then(m => m.default || m)
  },
  {
    name: frmBuscagwB3Xn369cMeta?.name ?? "videos-frmBusca",
    path: frmBuscagwB3Xn369cMeta?.path ?? "/videos/frmBusca",
    meta: frmBuscagwB3Xn369cMeta || {},
    alias: frmBuscagwB3Xn369cMeta?.alias || [],
    redirect: frmBuscagwB3Xn369cMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/videos/frmBusca.vue").then(m => m.default || m)
  },
  {
    name: indexhQQKpKdntUMeta?.name ?? "videos",
    path: indexhQQKpKdntUMeta?.path ?? "/videos",
    meta: indexhQQKpKdntUMeta || {},
    alias: indexhQQKpKdntUMeta?.alias || [],
    redirect: indexhQQKpKdntUMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/videos/index.vue").then(m => m.default || m)
  },
  {
    name: settingsuRIl0NJwAcMeta?.name ?? "videos-settings",
    path: settingsuRIl0NJwAcMeta?.path ?? "/videos/settings",
    meta: settingsuRIl0NJwAcMeta || {},
    alias: settingsuRIl0NJwAcMeta?.alias || [],
    redirect: settingsuRIl0NJwAcMeta?.redirect || undefined,
    component: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/pages/videos/settings.vue").then(m => m.default || m)
  }
]